import { render, staticRenderFns } from "./issues-filters.vue?vue&type=template&id=70f8878a&scoped=true&"
import script from "./issues-filters.vue?vue&type=script&lang=js&"
export * from "./issues-filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f8878a",
  null
  
)

export default component.exports